var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"drag",rawName:"v-drag"}],staticClass:"pointer"},[_vm._m(0),_c('el-image',{staticClass:"line",style:({
        top: _vm.scrollTop + 'px',
        zIndex: _vm.isDragging ? 0 : 1
      }),attrs:{"fit":"fill","src":_vm.lineSrc}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head"},[_c('i',{staticClass:"el-icon-caret-bottom"})])}]

export { render, staticRenderFns }